var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"update3-news"},[_c('div',{staticClass:"update-01"},[_vm._v("Update")]),_c('div',{staticClass:"update-text-01"},[_vm._v("Arman haque has won a tournament of $100")])])
}]

export { render, staticRenderFns }